import { Component, Input } from '@angular/core';
import {
    AssignmentBillResult,
    FlatAssignmentResult,
    Column,
} from '../../../shared/types/reports';

@Component({
    selector: 'las-assignments-report',
    templateUrl: './assignments-report.component.html',
    styleUrls: ['./assignments-report.component.scss'],
    standalone: false,
})
export class AssignmentsReportComponent {
    private _assignments: AssignmentBillResult[] = [];
    protected _flatAssignments: FlatAssignmentResult[] = [];

    @Input() user: any;
    @Input() set assignments(assignments: AssignmentBillResult[]) {
        this._assignments = assignments;
        this._flatAssignments = this.flatten(assignments);
        this.displayedAssignments = this._flatAssignments;
    }

    ascending = true;
    sortColumn = Column.Bill;
    displayedAssignments: FlatAssignmentResult[] = [];

    doSort(column: Column) {
        if (column === this.sortColumn) {
            this.ascending = !this.ascending;
        } else {
            this.sortColumn = column;
            this.ascending = true;
        }
    }

    ariaSort(column: Column): 'ascending' | 'descending' | 'none' {
        if (this.sortColumn !== column) return 'none';
        return this.ascending ? 'ascending' : 'descending';
    }

    onAssignmentsChanged(assignments: FlatAssignmentResult[]) {
        this.displayedAssignments = assignments;
    }

    onCollectionReset() {
        this.displayedAssignments = this._flatAssignments;
    }

    private flatten(
        assignments: AssignmentBillResult[],
    ): FlatAssignmentResult[] {
        return assignments.reduce((acc: FlatAssignmentResult[], bill) => {
            bill.assignmentList.forEach((assignment) => {
                acc.push({
                    billID: bill.billID,
                    measureType: bill.measureType,
                    measureNum: bill.measureNum,
                    measure: bill.measure,
                    subject: bill.subject,
                    primaryAuthor: bill.primaryAuthor,
                    ...assignment,
                });
            });
            return acc;
        }, []);
    }

    protected readonly Column = Column;
    protected readonly ArrowIcon = ArrowIcon;
}

enum ArrowIcon {
    Ascending = 'arrow_upward',
    Descending = 'arrow_downward',
}
